import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getSaleList: ({ searchParams }) => {
		let queryStr = '';
		if (searchParams.carCd !== undefined || searchParams.carCd !== undefined) {
			let stMonth = searchParams.startMonth;
			let stEnd = searchParams.endMonth;

			stMonth = moment(stMonth).startOf('month').format('YYYYMMDD');
			stEnd = moment(stEnd).endOf('month').format('YYYYMMDD');

			queryStr = objectToQuerystring({
				carCd: searchParams.carCd,
				startMonth: stMonth,
				endMonth: stEnd
			});
		}

		//console.log('시작>>>>', queryStr);

		return client
			.get(`${BASE_URL}/sample/v1/graphInfo` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getGraphList: ({ searchParams }) => {
		let queryStr = '';
		if (searchParams.selRowCarCd !== undefined || searchParams.selRowCarCd !== undefined) {
			let stMonth = searchParams.startMonth;
			let stEnd = searchParams.endMonth;

			stMonth = moment(stMonth).startOf('month').format('YYYYMMDD');
			stEnd = moment(stEnd).endOf('month').format('YYYYMMDD');

			queryStr = objectToQuerystring({
				carCd: searchParams.selRowCarCd,
				startMonth: stMonth,
				endMonth: stEnd
			});
		}

		//console.log('시작>>>>', queryStr);

		return client
			.get(`${BASE_URL}/sample/v1/graphInfo` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
